var DeviceActions = /** @class */ (function () {
    function DeviceActions() {
    }
    DeviceActions.prototype.setAvailable = function (devices) {
        return {
            type: DeviceActions.SET_AVAILABLE,
            payload: devices
        };
    };
    DeviceActions.prototype.setAudioInput = function (device) {
        return {
            type: DeviceActions.SET_INPUT,
            payload: device
        };
    };
    DeviceActions.prototype.setInputReady = function (state) {
        return {
            type: DeviceActions.SET_INPUT_READY,
            payload: state
        };
    };
    DeviceActions.prototype.setAudioOutput = function (device) {
        return {
            type: DeviceActions.SET_OUTPUT,
            payload: device
        };
    };
    DeviceActions.prototype.setAudioLabelledOutput = function (label, device) {
        return {
            type: DeviceActions.SET_LABELLED_OUTPUT,
            payload: {
                label: label,
                device: device
            }
        };
    };
    DeviceActions.prototype.setAudioOutputMuted = function (muted) {
        return {
            type: DeviceActions.SET_OUTPUT_MUTED,
            payload: muted
        };
    };
    DeviceActions.prototype.setAudioLabelledOutputMuted = function (label, muted) {
        return {
            type: DeviceActions.SET_LABELLED_OUTPUT_MUTED,
            payload: {
                label: label,
                muted: muted
            }
        };
    };
    DeviceActions.prototype.setVideoInput = function (device) {
        return {
            type: DeviceActions.SET_VIDEO_INPUT,
            payload: device
        };
    };
    DeviceActions.prototype.setVideoInputBitRate = function (bitRate) {
        return {
            type: DeviceActions.SET_VIDEO_INPUT_BIT_RATE,
            payload: bitRate
        };
    };
    DeviceActions.prototype.setAllDevices = function (devices) {
        return {
            type: DeviceActions.SET_ALL,
            payload: devices
        };
    };
    DeviceActions.prototype.setScreenShare = function (screen) {
        return {
            type: DeviceActions.SET_SCREEN_SHARE,
            payload: screen
        };
    };
    DeviceActions.prototype.setVideoTrackConstraints = function (constraints) {
        return {
            type: DeviceActions.SET_VIDEO_TRACK_CONSTRAINTS,
            payload: constraints
        };
    };
    DeviceActions.prototype.startInputFallback = function (state) {
        return {
            type: DeviceActions.INPUT_FALLBACK_START,
            payload: state
        };
    };
    DeviceActions.prototype.finishInputFallback = function (devices) {
        return {
            type: DeviceActions.INPUT_FALLBACK_FINISH,
            payload: devices
        };
    };
    DeviceActions.prototype.inputFallbackError = function (error) {
        return {
            type: DeviceActions.INPUT_FALLBACK_ERROR,
            payload: error
        };
    };
    DeviceActions.SET_AVAILABLE = 'RTC:DEVICES:SET_AVAILABLE';
    DeviceActions.SET_INPUT = 'RTC:DEVICES:SET_INPUT';
    DeviceActions.SET_INPUT_READY = 'RTC:DEVICES:SET_INPUT_READY';
    DeviceActions.SET_OUTPUT = 'RTC:DEVICES:SET_OUTPUT';
    DeviceActions.SET_OUTPUT_MUTED = 'RTC:DEVICES:SET_OUTPUT_MUTED';
    DeviceActions.SET_LABELLED_OUTPUT = 'RTC:DEVICES:SET_LABELLED_OUTPUT';
    DeviceActions.SET_LABELLED_OUTPUT_MUTED = 'RTC:DEVICES:SET_LABELLED_OUTPUT_MUTED';
    DeviceActions.SET_VIDEO_INPUT = 'RTC:DEVICES:SET_VIDEO_INPUT';
    DeviceActions.SET_ALL = 'RTC:DEVICES:SET_ALL';
    DeviceActions.SET_SCREEN_SHARE = 'RTC:DEVICES:SET_SCREEN_SHARE';
    DeviceActions.INPUT_FALLBACK_START = 'RTC:DEVICES:INPUT_FALLBACK_START';
    DeviceActions.INPUT_FALLBACK_FINISH = 'RTC:DEVICES:INPUT_FALLBACK_FINISH';
    DeviceActions.INPUT_FALLBACK_ERROR = 'RTC:DEVICES:INPUT_FALLBACK_ERROR';
    DeviceActions.SET_VIDEO_TRACK_CONSTRAINTS = 'RTC:DEVICES:SET_VIDEO_TRACK_CONSTRAINTS';
    DeviceActions.SET_VIDEO_INPUT_BIT_RATE = 'RTC:DEVICES:SET_VIDEO_INPUT_BIT_RATE';
    return DeviceActions;
}());
export { DeviceActions };
export default DeviceActions;
//# sourceMappingURL=devices.actions.js.map